import { AgendamentosProps } from '../types';

export const formataArrayDefault = (input: any[]): AgendamentosProps[] => {
  const transformed: AgendamentosProps[] = input.map((item) => {
    const [day, month, year] = item.dta_vencimento.split('/');

    const valorNumerico = Number(
      item.val_parcela
        .replace('R$', '')
        .replace('.', '')
        .replace(',', '.')
        .trim(),
    );

    return {
      cod_conta: item.cod_conta,
      cod_parcela: item.cod_parcela,
      tipo: item.tipo === 'Pagar' ? 0 : 1,
      dta_vencimento: `${year}-${month}-${day}`,
      val_parcela: valorNumerico,
      des_finalizadora: item.des_finalizadora,
      cod_finalizadora: item.cod_finalizadora,
    };
  });

  return transformed;
};
